// extracted by mini-css-extract-plugin
export var wordContainer = "_im-0";